import { BRAND, isBrandOV, isMarketGB } from 'src/constants/main';
import { InterestedBoxStyledAC } from './AC/InterestedBoxStyled.AC';
import { InterestedBoxStyledAP } from './AP/InterestedBoxStyled.AP';
import { InterestedBoxStyledDS } from './DS/InterestedBoxStyled.DS';
import { InterestedBoxStyledOV } from './OV/InterestedBoxStyled.OV';
import { InterestedBoxStyledOV as InterestedBoxStyledOV_GB } from './OV/GB/InterestedBoxStyled.OV';
import { InterestedBoxStyled } from './InterestedBoxStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { Pages } from 'src/types/pages';

export interface InterestedBoxProps extends SC {
    secondary?: boolean;
    page: Pages;
    fullWidth?: boolean;
    isLegalText?: boolean;
    onClickPhone?: (label?: string) => void;
    onClickCta?: (label?: string) => void;
    onClickRequestMore?: (label?: string) => void;
    hideContinueButton?: boolean;
}

const InterestedBox = (props: InterestedBoxProps) => {
    if (isBrandOV) return isMarketGB ? <InterestedBoxStyledOV_GB {...props} /> : <InterestedBoxStyledOV {...props} />;
    if (BRAND === 'AC') return <InterestedBoxStyledAC {...props} />;
    if (BRAND === 'AP') return <InterestedBoxStyledAP {...props} />;
    if (BRAND === 'DS') return <InterestedBoxStyledDS {...props} />;
    return <InterestedBoxStyled {...props} />;
};

export default InterestedBox;
